define('views/content/reports/cd_stocks',['require','backbone','marionette','datatables','text!templates/content/reports/cd_stocks.html'],function(require){

    var Backbone = require('backbone');
    require('marionette');
    require('datatables');

    var temp = require("text!templates/content/reports/cd_stocks.html");

    return Backbone.Marionette.CompositeView.extend({
        // html template for the view
        template: _.template(temp),
        className: 'report-page',
        titleKey: 'cd_stocks',

        initialize: function(options) {
            App.context.changePageTitle(App.polyglot.t(this.titleKey));
        },

        ui: function() {
            return {
                cdStocksTable: '.cd-stocks-list'
            };
        },

        onRender: function () {
            this.getReports();
        },

        getReports: function () {
            var _this = this;

            $.ajax({
                url: App.Config.apiBase + 'reports/cd-stock-reports/',
                method: 'get',
                success: function (response) {
                    _this.showCDStockReports(response.cd_stock_report);
                }
            });
        },

        showCDStockReports: function (reportData) {
            // Transform report data for datatables format
            var gridColumns = [
                { title: App.polyglot.t('country_distributor') },
                { title: App.polyglot.t('days_since_last_purchase'), className: 'text-right' }
            ];

            var totalRow = {};
            var products = reportData[0].products;

            products.forEach(function (product) {
                gridColumns.push({title: product.name, className: 'text-right'});
                totalRow[product.id] = 0;
            });

            var gridData = [];
            reportData.forEach(function (reportRow) {
                var rowData = [
                    reportRow.country_distributor.name ,
                    reportRow.last_purchase_days
                ];

                reportRow.products.forEach(function (product) {
                   rowData.push(product.count);

                   totalRow[product.id] += product.count;
                });

                gridData.push(rowData);
            });

            // Add total row
            var totalRowData = [
                App.polyglot.t('total'),
                ''
            ];

            products.forEach(function (product) {
               totalRowData.push(totalRow[product.id]);
            });
            gridData.push(totalRowData);

            if (!this.cdStocksDataTable) {
                this.cdStocksDataTable = this.ui.cdStocksTable.DataTable({
                    paging: false,
                    ordering: false,
                    info: false,
                    searching: false,
                    data: gridData,
                    fixedHeader: true,
                    scrollY: App.utils.getContainerHeightWOffset(this.ui.cdStocksTable),
                    columns: gridColumns,
                    buttons: [
                        'print'
                    ]
                });
            } else {
                this.cdStocksDataTable.clear();
                this.cdStocksDataTable.rows.add(gridData);
                this.cdStocksDataTable.columns.adjust().draw();
            }
        }

    });
});
